// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"149":"fbece3c1","163":"14354608","383":"b3068cc2"}[chunkId] + ".js";
};